import { Button, Grid, useMediaQuery } from "@mui/material";
import "./App.css";
import BookScreen from "./screen/bookSreen";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ReactGA from "react-ga4";
import { useEffect, useState } from "react";
import { pageViewed } from "./helper/helper";
import Header from "./components/header";
import { getPrice } from "./service/api";

const THEME = createTheme({
  typography: {
    fontFamily: `"Open Sans", sans-serif`,
    fontSize: 14,
    fontWeightRegular: 500,
  },
  palette: {
    primary: {
      main: "#1b66b2", // text color
    },

    red: "#D20000",
  },
});
function App() {
  const trackStepViewed = () => {
    ReactGA.event({
      category: "Stepper",
      action: `Step ${1} Viewed`,
    });
  };

  useEffect(() => {
    trackStepViewed();
    pageViewed("Step 1");
  }, []);

  const isMobile = useMediaQuery("(max-width:800px)");
  return (
    <ThemeProvider theme={THEME}>
      <div style={{ marginBottom: "50px" }}>
        <div style={{ paddingBottom: "110px" }}>
          <Header />
        </div>

        <div
          style={{
            padding: isMobile ? 5 : 50,
            marginBottom: isMobile ? 30 : 5,
          }}
        >
          <BookScreen />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;
